import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import {
  ThemeProvider,
  ThemeType,
  applyColorMode,
  getStoredColorMode,
} from './components/theme-provider';
import { queryClient } from './lib/query-client';
import './i18n/config';
import './app/globals.css';

const getTheme = (): ThemeType => {
  const stored = localStorage.getItem('theme') as ThemeType | null;
  if (stored && Object.values(ThemeType).includes(stored)) return stored;

  const theme =
    window.location.hostname === 'agente.houdini.mx'
      ? ThemeType.HOUDINI_THEME
      : ThemeType.MENTEO_THEME;
  localStorage.setItem('theme', theme);
  return theme;
};

// Paint the right mode before the first render, so a dark-mode user never sees
// a white flash while React boots.
applyColorMode(getStoredColorMode());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={getTheme()}>
          <App />
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
